import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import type { CommitteeAssignmentWithCommittee } from "../types";

export type DeleteCommitteeAssignmentDialogProps = {
  open: boolean;
  assignment: CommitteeAssignmentWithCommittee | null;
  saving?: boolean;
  onClose(): void;
  onConfirm(): void;
};

export default function DeleteCommitteeAssignmentDialog({
  open,
  assignment,
  saving = false,
  onClose,
  onConfirm
}: DeleteCommitteeAssignmentDialogProps) {
  const participantName = assignment?.person?.displayName ?? "this person";

  return (
    <Dialog
      open={open}
      headline="Delete Participation?"
      onClosed={onClose}
      actions={
        <>
          <Button variant="text" onClick={onClose} testId="delete-committee-assignment-cancel" disabled={saving}>
            Cancel
          </Button>
          <Button
            variant="filled"
            theme="error"
            onClick={onConfirm}
            disabled={!assignment || saving}
            testId="delete-committee-assignment-confirm"
          >
            Delete
          </Button>
        </>
      }
    >
      <p className="text-body-medium">
        This removes <strong>{participantName}</strong> from the committee roster. The participation record is kept for
        history but will no longer appear in committee lists.
      </p>
    </Dialog>
  );
}
